'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:singleSelect');
}

var _invoke = require('../invoke');

/**
 * 单选框
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name singleSelect
 * @param {Array} menus 选项数组
 * @return {Undefined}
 * @example
 *  hbnb.ui.singleSelect([{
 *      label: 'all',
 *      active: true,
 *      callback: function() {},
 *  }, {
 *      label: 'option 1',
 *      active: false,
 *      callback: function() {},
 *  }, {
 *      label: 'option 2',
 *      active: false,
 *      callback: function() {},
 *  }]);
 */
module.exports = function(menus) {
    if (process.env.NODE_ENV !== 'production') {
        debug('menus is %j', menus);
    }

    _invoke('ui', 'single_select', {
        menus: menus
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/ui/single-select.js
// module id = 655
// module chunks = 0